import Icon from '@mdi/react';
import Select, { ActionMeta, MultiValue, SingleValue } from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

interface GeneralMultiselectInputProps<T> {
	options: Array<{ value: T; label: string }>;
	isMulti?: boolean;
	closeMenuOnSelect?: boolean;
	blurInputOnSelect?: boolean;
	onChange?: (
		selectedOption:
			| MultiValue<{ value: T; label: string }>
			| SingleValue<{ value: T; label: string }>,
		actionMeta: ActionMeta<{ value: T; label: string }>
	) => void;
	value?: MultiValue<{ value: T; label: string }> | SingleValue<{ value: T; label: string }>;
	placeholder?: string;
	iconPath?: string;
}

export const GeneralMultiselectInput = <T,>({
	options,
	isMulti = true,
	closeMenuOnSelect = false,
	blurInputOnSelect = false,
	onChange,
	value,
	placeholder = 'Select...',
	iconPath,
}: GeneralMultiselectInputProps<T>) => {
	return (
		<div className="relative w-full">
			<div
				className="absolute left-3 z-10"
				style={{
					top: '8px',
					transform: 'translateY(0)',
				}}
			>
				<Icon path={iconPath ?? ''} size={1} className="text-gray-500" />
			</div>
			<Select
				components={{ ...animatedComponents }}
				closeMenuOnSelect={closeMenuOnSelect}
				blurInputOnSelect={blurInputOnSelect}
				isMulti={isMulti}
				options={options}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				styles={{
					control: (baseStyles) => ({
						...baseStyles,
						paddingLeft: '30px',
						width: '100%',
						borderColor: '#7B809A',
						'&:hover': {
							borderColor: '#7B809A',
						},
						boxShadow: 'none',
					}),
					container: (base) => ({
						...base,
						width: '100%',
					}),
					menu: (base) => ({
						...base,
						zIndex: 11,
					}),
					multiValue: (baseStyles) => ({
						...baseStyles,
						backgroundColor: '#E9ECEF',
						borderRadius: '45px',
						padding: '3px 5px',
					}),
					multiValueLabel: (baseStyles) => ({
						...baseStyles,
						color: '#495057',
					}),
					multiValueRemove: (baseStyles) => ({
						...baseStyles,
						borderRadius: '50%',
						width: '20px',
						height: '20px',
						padding: '3px',
						marginTop: '4px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						color: '#7B809A',
						'&:hover': {
							backgroundColor: '#CED4DA',
							color: '#00AB89',
						},
					}),
				}}
			/>
		</div>
	);
};
